import styled from 'styled-components/native'

import { ProximaNova } from '../TextComponent'

export const PoweredBy = styled(ProximaNova)`
    text-align: center;
    margin: 20px 0 30px 0;
    border-radius: 10px;
`
